export const MAX_EVENT_DETAILS_LENGTH = 1000
